module.exports = __webpack_public_path__ + "img/govtech.3f53f6b1.png";